<div class="login-wrapper">

    <div class="logo mt-4">
        <img src="login-logo.png" alt="logo" />
    </div>
    <div class="form-container d-flex flex-column mt-4">

        <div class="login-container">
            <h4 class="mb-4">Welcome To The Catalog Management Tool</h4>
            <form (keydown.enter)="login()" #loginForm="ngForm">
                <div class="mx-2 mb-2">
                    <label class="form-label text-left">User ID</label>
                    <div class="input-wrapper">
                        <span class="px-0" nz-icon nzType="user"></span>
                        <input [(ngModel)]="username" required name="username" type="text" class="form-control"
                            placeholder="MOJO User Id">
                    </div>
                    <span class="text-danger" *ngIf="emptyCreds && !username">User ID is required</span>
                </div>
                <div class="d-flex flex-column mx-2 mb-3">
                    <label class="form-label text-left">Password</label>
                    <div class="input-wrapper">
                        <input [(ngModel)]="password" required name="password" [type]="viewPassword ? 'text':'password'"
                            class="form-control" placeholder="******">
                        <!-- <span style="cursor: pointer;" (click)="togglePassword()" nz-icon
                            [nzType]="viewPassword ? 'eye':'eye-invisible'"></span> -->
                        <img style="cursor: pointer;" (click)="togglePassword()" [src]="viewPassword ? 'eye-visible.svg':'eye-invisible.svg'"  width="18px"
                            height="18px" />
                    </div>
                    <span class="text-danger" *ngIf="emptyCreds && !password">Password is required</span>
                </div>
                <div class="mx-2 mt-3 button-block text-center">
                    <button (click)="login()" type="button" class="btn btn-primary w-100 login-btn mb-4">Login</button>
                </div>
            </form>
        </div>

        <section class="footer-area" [ngClass]="zoomLevel >= 125 ? 'footer-area-zoom' : 'footer-area-zoom'">
            <div class="footer-text">
                <span>&copy; {{currentYear}} Workwear Outfitters, LLC. All rights reserved.
                    <br><br>Red Kap, Bulwark FR, Workrite Fire Service, Walls, Liberity, Kodiak, Terra, Horace Small,
                    Work
                    Authority, Image Authority and CritiCore are brands of Workwear Outfitters.<br>Dickies is a
                    trademark of
                    W.D Apparel Company, LLC Manufactured under license.<br>Image Authority is a division of
                    Workwear Outfitters.</span>

            </div>
        </section>


    </div>
</div>